/**
 * The URL for an SVG Icon for the set symbol hosted by Scryfall.
 */
export function setSymbolURL(setCode: string | null) {
  if (setCode == null) {
    return undefined
  }

  return `https://svgs.scryfall.io/sets/${setCode.toLowerCase()}.svg`
}
